const validation = {
	boolean_required_true: {
		invalid: "Dieses Kontrollkästchen ist erforderlich.",
	},
	coc: {
		invalid: "Geben Sie eine gültige Handelsregisternummer ein",
		same_as_tuxis: "Die Handelsregisternummer ist dieselbe wie Tuxis",
	},
	dadup: {
		invalid_bucket_name: "Es sind nur Buchstaben und Zahlen zulässig.",
		invalid_display_name:
			"Es sind nur Buchstaben, Zahlen, Leerzeichen und die Zeichen „-_“ zulässig. Der Name darf jedoch nicht mit einem „-“ oder „_“ beginnen.",
	},
	datastore_name: {
		invalid: "Es sind nur Buchstaben, Zahlen und die Zeichen '-_' erlaubt.",
	},
	date: {
		invalid: "Geben Sie ein gültiges Datum ein.",
	},
	date_of_birth: {
		invalid: "Das eingegebene Geburtsdatum muss mindestens 6 Jahre zurückliegen.",
	},
	dns: {
		invalid: "Die Eingabe entspricht nicht einem gültigen DNS-Format.",
	},
	email: {
		invalid: "Geben Sie eine gültige E-Mail-Adresse ein.",
	},
	errors: {
		ssh_key_invalid: "Der SSH-Schlüssel hat einen ungültigen Typ oder eine ungültige Beschreibung",
		unknown:
			"Etwas ist schiefgegangen... bei anhaltenden Problemen empfehlen wir, uns zu kontaktieren.",
	},
	house_number: {
		invalid: "Geben Sie eine gültige Hausnummer ein. Die Hausnummer darf nur Ziffern enthalten.",
	},
	input_free_text: {
		invalid: "Nur Buchstaben, Zahlen, Leerzeichen und die Zeichen '.-+@!#$%^&*()=' sind erlaubt.",
		max_length: "Verwenden Sie maximal {{length}} Zeichen.",
		min_length: "Verwenden Sie mindestens {{length}} Zeichen.",
	},
	input_number: {
		max_length: "Die Zahl darf nicht größer als {{length}} sein.",
		min_length: "Die Zahl darf nicht kleiner als {{length}} sein.",
		only_numbers: "Sie können nur Zahlen verwenden.",
	},
	input_select: {
		invalid: "Wählen Sie einen gültigen Wert",
	},
	input_text: {
		invalid: "Die folgenden Zeichen sind nicht erlaubt: '.-'",
		max_length: "Verwenden Sie maximal {{length}} Zeichen.",
		min_length: "Verwenden Sie mindestens {{length}} Zeichen.",
	},
	name: {
		invalid:
			"Der eingegebene Name enthält Zeichen, die nicht zulässig sind. Verwenden Sie nur Buchstaben, Leerzeichen und die Zeichen , . - '",
	},
	otp: {
		invalid:
			"Ihr 2FA-Code ist falsch oder verfallen! Versuchen Sie es erneut mit einem neuen Code.",
		only_numbers: "Ihr 2FA-Code darf nur aus Zahlen bestehen.",
	},
	oxxa_company_name: {
		invalid:
			"Der eingegebene Firmenname entspricht nicht unseren Anforderungen an Dritte. Der Firmenname darf nur aus Buchstaben, Zahlen, Leerzeichen und den Zeichen &-().' bestehen.",
	},
	password: {
		invalid: "Ihr Passwort ist falsch!",
		invalid_current: "Ihr aktuelles Passwort ist falsch!",
		no_change: "Ihr neues Passwort und Ihr aktuelles Passwort sind identisch.",
		no_match: "Das Bestätigungskennwort stimmt nicht mit dem Kennwort überein.",
		to_weak: "Das Passwort entspricht nicht unseren Anforderungen",
		tooltip:
			"Verwenden Sie mindestens 12 Zeichen (Kleinbuchstaben, Großbuchstaben, Zahlen und Sonderzeichen).",
	},
	phone: {
		invalid:
			"Geben Sie eine gültige Rufnummer ein. Erlaubt sind Ziffern, Leerzeichen und das Zeichen -",
		too_few_phone_number_digits:
			"In das Rufnummernfeld müssen mindestens {{length}} Ziffern eingegeben werden.",
		too_many_phone_number_digits:
			"In das Rufnummernfeld können bis zu {{length}} Ziffern eingegeben werden.",
	},
	product_number_hostfact_invalid: {
		invalid:
			"Die Hostfact-Nummer entspricht nicht dem Format. Die Nummer sollte mit einem P beginnen und von 3 bis 6 Ziffern gefolgt werden (P000 oder P000000)",
	},
	proxmox_fingerprint: {
		invalid: "Ungültiger Fingerabdruck: entspricht nicht dem Proxmox-Regex.",
	},
	proxmox_host: {
		invalid: "Ungültiger Hostname: entspricht nicht dem Proxmox-Regex.",
	},
	proxmox_regex: {
		invalid: "Feldeingabe entspricht nicht dem Proxmox-Regex.",
	},
	proxmox_regex_free: {
		invalid: "Feldeingabe entspricht nicht dem Proxmox-Regex.",
	},
	proxmox_token_name: {
		invalid: "Ungültiger Tokenname: entspricht nicht dem Proxmox-Regex.",
	},
	proxmox_user_name: {
		invalid: "Ungültiger Benutzername: entspricht nicht dem Proxmox-Regex.",
	},
	required: "Eingabefeld erforderlich!",
	snapshot: {
		invalid:
			'Der Name Ihres Snapshots entspricht nicht dem richtigen Format. Verwenden Sie Buchstaben, Zahlen und/oder Bindestriche. Verwenden Sie keine Leerzeichen. Das Wort "portal" ist nicht erlaubt.',
	},
	ssh_public_key: {
		invalid:
			"Ihr SSH-Schlüsselformat ist falsch. Es werden nur OpenSSH-Standardformate unterstützt.",
	},
	username: {
		exist: "Dieser Benutzername ist bereits vergeben!",
		invalid:
			"Der Benutzername entspricht nicht den Anforderungen! Verwenden Sie Buchstaben, Zahlen, Bindestriche und/oder At-Zeichen.",
	},
	vat_number: {
		invalid: "Geben Sie eine gültige USt-IdNr. ein",
		same_as_tuxis: "Die USt-IdNr. ist dieselbe wie Tuxis",
	},
	zip_code: {
		invalid: "Geben Sie eine gültige Postleitzahl ein.",
	},
};

export default validation;
